var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9983 4.37859e-08C13.8503 6.54375e-09 14.2953 0.986 13.7813 1.623L13.7053 1.707L7.7053 7.707C7.5331 7.87918 7.304 7.98261 7.06098 7.99789C6.81795 8.01317 6.5777 7.93925 6.3853 7.79L6.2913 7.707L0.291296 1.707L0.208296 1.613L0.154297 1.536L0.100296 1.44L0.0832959 1.404L0.0562974 1.337L0.0242959 1.229L0.0142975 1.176L0.00429731 1.116L0.000297593 1.059L-0.00170322 1L0.000297588 0.941001L0.00529675 0.883001L0.0142975 0.823001L0.0242958 0.771001L0.0562973 0.663001L0.0832958 0.596L0.153297 0.464L0.218296 0.374L0.291296 0.293001L0.385296 0.210001L0.462297 0.156001L0.558296 0.102001L0.594297 0.0850006L0.661297 0.0580002L0.769297 0.0260006L0.822296 0.0160004L0.882298 0.00600014L0.939297 0.00200043L12.9983 4.37859e-08Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.5cb1c9a57b6b11d364696c821aaef957.svg";
export { ForwardRef as ReactComponent };